(function () {
  'use strict';

  function generateNewBackground(prediction) {
    var currentAIName = fixtures.currentAI?.name || 'Character';

    // Build search query from current AI and prediction
    var searchQuery = '';
    if (currentAIName) {
      searchQuery += currentAIName.substring(0, 40) + ' ';
    }
    if (prediction) {
      var cleanPrediction = prediction.replace(/[^a-zA-Z0-9 ]/g, ' ').trim();
      searchQuery += cleanPrediction + ' ';
    }

    // Add background-related terms for better matching
    searchQuery += 'background scenery environment peaceful relaxing';
    searchQuery = searchQuery.trim();

    // Use the new background search API instead of generating
    searchBackgrounds(searchQuery)
      .then(function (backgrounds) {
        if (backgrounds && backgrounds.length > 0) {
          // Pick the first result (most relevant)
          var selectedBackground = backgrounds[0];
          var backgroundPath = selectedBackground.url;

          var preloadImage = window.ImageUtils
            ? window.ImageUtils.preloadImage
            : function (path, callback) {
                callback();
              };
          preloadImage(backgroundPath, function () {
            requestAnimationFrame(() => {
              setBackground(backgroundPath);
            });
          });
        } else {
          // Fallback to generation if no backgrounds found
          console.log('No backgrounds found, falling back to generation');
          generateBackgroundFallback(prediction);
        }
      })
      .catch(function (error) {
        console.error('Background search failed:', error);
        // Fallback to generation on error
        generateBackgroundFallback(prediction);
      });
  }

  // Fallback function for background generation (original logic)
  function generateBackgroundFallback(prediction) {
    var currentAIName = fixtures.currentAI?.name || 'Character';
    currentAIName = currentAIName.substring(0, 40);

    var backgroundModifier = '';
    try {
      var backgroundModifiers = [
        'nostalgic colorful relaxing chill realistic cartoon illustration fantasy abstract impressionist watercolor painting Background location scenery neutrals beautiful charming picturesque'.split(
          ' '
        ),
      ];
      var hash = window.CollectionUtils
        ? window.CollectionUtils.hashCode(prediction)
        : prediction.length;
      var numBackgroundModifiersChosen = (hash % 5) + 1;
      backgroundModifiers = window.CollectionUtils
        ? window.CollectionUtils.shuffle(backgroundModifiers, hash)
        : backgroundModifiers;
      backgroundModifier = backgroundModifiers[0]
        .slice(0, numBackgroundModifiersChosen)
        .join(' ');
    } catch (e) {
      console.error(e);
      backgroundModifier = '';
    }

    var predictionPrompt = window.StringUtils
      ? window.StringUtils.sanitizePrompt(prediction)
      : prediction;
    predictionPrompt = predictionPrompt.replace(/[^a-zA-Z0-9 ]/g, '');
    predictionPrompt = predictionPrompt || '';
    backgroundModifier = backgroundModifier || '';
    currentAIName = currentAIName || '';
    var bgPrompt = `Backdrop background environment neutral colors artstation ${backgroundModifier} ${currentAIName} ${predictionPrompt}`;
    bgPrompt = window.StringUtils
      ? window.StringUtils.sanitizePrompt(bgPrompt)
      : bgPrompt;
    var bgPromptKey = encodeURIComponent(bgPrompt.replaceAll(' ', '-'));

    if (window.dataAccessor && window.dataAccessor.makeAIImage) {
      window.dataAccessor
        .makeAIImage(bgPrompt, bgPromptKey, 1360, 768)
        .then(function (response) {
          var preloadImage = window.ImageUtils
            ? window.ImageUtils.preloadImage
            : function (path, callback) {
                callback();
              };
          preloadImage(response.path, function () {
            requestAnimationFrame(() => {
              setBackground(response.path);
            });
          });
        });
    }
  }

  // Fallback backgrounds for immediate functionality
  var fallbackBackgrounds = [
    {
      name: 'peaceful landscape',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-nostalgic-colorful-relaxing-chill-realistic.webp',
    },
    {
      name: 'serene nature',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiartstation-art-sweeping-landscape-fields-of-flowers-peaceful-relaxing-confident-engaging-wow-3-wide.webp',
    },
    {
      name: 'abstract art',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-nostalgic-colorful.webp',
    },
    {
      name: 'fantasy scenery',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-nostalgic-colorful-relaxing.webp',
    },
    {
      name: 'anime style',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-anime.webp',
    },
    {
      name: 'cyberpunk',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-cyberpunk.webp',
    },
    {
      name: 'medieval castle',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-medieval.webp',
    },
    {
      name: 'space stars',
      url: 'https://netwrckstatic.netwrck.com/static/uploads/aiBackdrop-background-environment-neutral-colors-artstation-space.webp',
    },
  ];

  // Function to search backgrounds using the existing API
  function searchBackgrounds(query) {
    return fetch(
      '/api/search-backgrounds?q=' + encodeURIComponent(query) + '&limit=5'
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function (data) {
        var results = [];

        // Convert the API response format
        if (Array.isArray(data)) {
          results = data.map(function (item) {
            return {
              name: item.name || item.Name,
              filename: item.avatar_filename || item.AvatarFileName,
              url: `https://netwrckstatic.netwrck.com/static/uploads/${item.avatar_filename || item.AvatarFileName}`,
            };
          });
        } else if (data.results) {
          results = data.results.map(function (item) {
            return {
              name: item.name,
              filename: item.filename || item.file_name,
              url: item.url, // Use the direct URL from the API
            };
          });
        }

        // If no results from API, use fallback backgrounds with simple keyword matching
        if (results.length === 0) {
          var queryLower = query.toLowerCase();
          var matchedBackgrounds = fallbackBackgrounds.filter(function (bg) {
            var nameLower = bg.name.toLowerCase();
            // Simple keyword matching
            if (queryLower.includes('anime') && nameLower.includes('anime'))
              return true;
            if (queryLower.includes('nature') && nameLower.includes('nature'))
              return true;
            if (
              queryLower.includes('landscape') &&
              nameLower.includes('landscape')
            )
              return true;
            if (queryLower.includes('fantasy') && nameLower.includes('fantasy'))
              return true;
            if (
              queryLower.includes('peaceful') &&
              nameLower.includes('peaceful')
            )
              return true;
            if (queryLower.includes('space') && nameLower.includes('space'))
              return true;
            if (queryLower.includes('cyber') && nameLower.includes('cyberpunk'))
              return true;
            if (
              queryLower.includes('medieval') &&
              nameLower.includes('medieval')
            )
              return true;
            return false;
          });

          // If no matches, return first few fallback backgrounds
          if (matchedBackgrounds.length === 0) {
            matchedBackgrounds = fallbackBackgrounds.slice(0, 3);
          }

          results = matchedBackgrounds;
        }

        return results;
      });
  }

  function setBackground(bgImageName) {
    if (!bgImageName) return;

    var newBackgroundUrl;
    if (
      bgImageName.startsWith('http://') ||
      bgImageName.startsWith('https://') ||
      bgImageName.startsWith('/')
    ) {
      newBackgroundUrl = bgImageName;
    } else {
      newBackgroundUrl = `/static/images/backgrounds/${bgImageName}`;
    }

    var applyBackground = function () {
      var $backdrops = $('.backdrop-ai-1, .backdrop-ai-2');
      if ($backdrops.length >= 2) {
        window.backgroundChangeNum = window.backgroundChangeNum || 1;
        var $oldEl = $('.backdrop-ai-' + window.backgroundChangeNum);
        window.backgroundChangeNum =
          window.backgroundChangeNum === 1 ? 2 : 1;
        var $newEl = $('.backdrop-ai-' + window.backgroundChangeNum);
        var currentBackground = $oldEl.css('background');
        if (currentBackground && currentBackground !== 'none') {
          $newEl.css('background', currentBackground);
        }
        $newEl.css({ display: 'block', opacity: 0 });
        $oldEl.css({ display: 'block', opacity: 1 });
        requestAnimationFrame(function () {
          $newEl.css({
            transition: 'opacity 0.5s ease-in-out',
            background: `url(${newBackgroundUrl}) no-repeat center center fixed`,
            'background-size': 'cover',
            opacity: 1,
          });
          $oldEl.css('opacity', 0);
          setTimeout(function () {
            requestAnimationFrame(function () {
              $oldEl.css('background', $newEl.css('background'));
              $oldEl.css('opacity', 1);
            });
          }, 500);
        });
      }
      $('body').css('background-image', `url('${newBackgroundUrl}')`);
    };

    if (window.ImageUtils && window.ImageUtils.preloadImage) {
      window.ImageUtils.preloadImage(newBackgroundUrl, function () {
        requestAnimationFrame(applyBackground);
      });
    } else {
      requestAnimationFrame(applyBackground);
    }
  }

  window.BackgroundUtils = {
    generateNewBackground: generateNewBackground,
    setBackground: setBackground,
    searchBackgrounds: searchBackgrounds,
    generateBackgroundFallback: generateBackgroundFallback,
  };
})();
